import Lottie from "lottie-react";
import animationData from "./yellowclockslow.json";

const WatchLottieIcon = () => {
  return (
    <div style={{ width: 50, height: 50 , display: 'inline-block', marginLeft: '10px' }}>
      <Lottie animationData={animationData} loop={true}  autoplay={true}
        initialSegment={[0, 240]}
       />
    </div>
  );
};

export default WatchLottieIcon;
